import AddressFormField from './AddressFormField';

const AddressFormRow = (props) => {
  const { addressArray, schema, requiredFields } = props;
  if (addressArray.length === 0) {
    return null;
  }
  if (addressArray.length > 1) {
    return (
      <div className="c7-form__group">
        {addressArray.map((element) => (
          <AddressFormField
            element={element}
            schema={schema}
            key={element}
            requiredFields={requiredFields}
          />
        ))}
      </div>
    );
  }
  return addressArray.map((element) => (
    <AddressFormField
      element={element}
      schema={schema}
      key={element}
      requiredFields={requiredFields}
    />
  ));
};

export default AddressFormRow;
